<template>
  <div
    id="searchFilter"
    class="search-head collapse-content"
  >
    <div>
      <v-row>
        <v-col cols md="4">
          <v-text-field
            :placeholder="$t('Поиск по названию или номеру')"
            v-model="search.name"
            required
            outlined
            dense
            clearable
          />
        </v-col>
        <v-col cols md="4">
          <v-row>
            <v-col cols md="6" class="date">
              <v-menu
                v-model="search.menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="search.dateFrom"
                    readonly
                    v-on="on"
                    outlined
                    dense
                    clearable
                    :placeholder="$t('Дата с')"
                  />
                </template>
                <v-date-picker
                  v-model="search.dateFrom"
                  :weekday-format="getDay"
                  :month-format="getMonthFormat"
                  :header-date-format="getHeaderDateFormat"
                  no-title
                  first-day-of-week="1"
                />
              </v-menu>
            </v-col>
            <v-col cols md="6" class="date">
              <v-menu
                v-model="search.menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="search.dateTo"
                    readonly
                    v-on="on"
                    outlined
                    dense
                    clearable
                    :placeholder="$t('Дата по')"
                  />
                </template>
                <v-date-picker
                  v-model="search.dateTo"
                  no-title
                  :weekday-format="getDay"
                  :month-format="getMonthFormat"
                  :header-date-format="getHeaderDateFormat"
                  first-day-of-week="1"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
        <div class="execution_laws"> 
          <v-checkbox
            v-model="search.executionLawsChosen"
            label="Исполнение законов"
            hide-details>
          </v-checkbox>
        </div>
      </v-row>
      <v-row>
        <v-col cols md="4">
          <div class="select-def">
            <v-select
              :items="data.refDeveloper"
              item-value="id"
              item-text="transName"
              v-model="search.developer"
              :placeholder="$t('Разработчик')"
              required
              outlined
              dense
              clearable
            >
              <template v-slot:item="{ item }">
                <v-list-item-icon class="select-def__icon">
                  <v-icon :class="item.status === false ? 'nv_icon' : ''" x-small/>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.transName }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-select>
          </div>
        </v-col>
        <v-col cols md="4" v-if="user && (user.roleAdmin === true || user.roleCoordinator)">
          <div class="select-def" v-if="isEnforecement">
            <v-select
              :items="data.refLawStatus"
              item-value="id"
              item-text="transName"
              v-model="search.status"
              :placeholder="$t('Статус в базе данных')"
              required
              outlined
              dense
              clearable
            />
          </div>
        </v-col>
        <v-col cols md="4">
          <div class="select-def">
            <v-select
              :items="data.refKindOfLaw"
              item-value="id"
              item-text="transName"
              v-model="search.kind"
              :placeholder="$t('Вид закона')"
              required
              outlined
              dense
              clearable
            />
          </div>
        </v-col>
      </v-row>
      <!------------>
      <v-row>
        <!------------>
        <v-col cols md="4">
          <div class="select-def">
            <v-select
              :items="data.refLawType"
              item-value="id"
              item-text="transName"
              v-model="search.type"
              :placeholder="$t('Тип закона')"
              required
              outlined
              dense
              clearable
            />
          </div>
        </v-col>
        <!------------>
        <v-col cols md="4">
          <div class="select-def">
            <v-select
              :items="data.zbdStatus"
              item-value="id"
              item-text="transName"
              v-model="search.zbdStatus"
              :placeholder="$t('Статус закона')"
              required
              outlined
              dense
              clearable
            />
          </div>
        </v-col>
        <!------------>
        <v-col cols md="4">
          <div class="select-def">
            <v-select
              :items="data.refExecutionOfLaw"
              item-value="id"
              item-text="transName"
              v-model="search.executionOfLaw"
              :placeholder="$t('Исполнение законов')"
              required
              outlined
              dense
              clearable
            />
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="form-action" cols sm="12" md>
          <button
            class="btn btn-default blue"
            @click="searchLaw()"
          >
            {{ $t('Поиск') }}
          </button>
          <button
            class="btn btn-default white"
            @click=";(search = {}), resetLaw()"
          >
            {{ $t('Очистить') }}
          </button>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import mixin from '@/plugins/mixin/mixin'

  export default {
    mixins: [mixin],
    name: "LawSearch",
    props: {
      data: [Array, Object],
      user: [Object, Array],
      viewName: {
        type: String,
        default: ''
      }
    },
    data: () => ({
      search: {
        executionLawsChosen: false
      },
      sorting: {},
    }),

    mounted () {
      if (!this.isEnforecement) {
        this.search.executionLawsChosen = true
        this.$forceUpdate()
      }
    },

    computed: {
      //Убрать потом условие админа
      isEnforecement() {
        return this.viewName != 'viewName'
      },
      listLocal: {
        get() {
          return this.refDeveloper
        }
      }
    },
    methods: {
      searchLaw () {
        this.$emit('searchLaw', this.search)
      },
      resetLaw () {
        this.$emit('resetLaw', this.search)
      },
    }
  }
</script>

<style scoped>
  .execution_laws {
    margin-left: 10px;
    margin-top: 7px;
  }
</style>
